module.exports = __webpack_public_path__ + "static/avatar_mitya_fomin@2x-8215c7c30e3689ca4ec36ccc25f34fc9.jpg";